import { useMe, useModuleBrokerConnection } from '@ctcells/api'
import { errorMessage, t } from '@ctcells/i18n'

import { canBroker, MODULE_BROKER_READ } from '../admin/brokerModel.ts'
import { useScreenAccess } from '../screenAccess.ts'

import { ModuleBrokerRow } from './ModuleBrokerCards.tsx'

/**
 * 모듈 서랍 「연결」 카드의 「브로커 주소」 줄 컨테이너(`IFC-RO-78` · admin · eric 2026-10-22 「브로커 접속 빼고.. 브로커 주소..를 연결에 넣고」).
 *
 * 🔴 **조회만 한다** — 「접속 바꾸기」(eric 2026-10-22 「변경 접속 바꾸기 버튼 없애줘」) · 「모듈 ID 바꾸기」(같은 날 「모듈 관리 카드 제거해줘」)는
 *    걷었다. 쓰기 API 훅(`useChangeModuleBrokerConnection` · `useChangeModuleIdentity`)은 `@ctcells/api` 에 남아 있다.
 * 🔴 **admin 이 아니면 조회를 «부르지 않는다»** — `GET /modules/{id}/broker` 는 admin 한정이고, 부르면 코어가 모듈에 HTTP 를 쏜다.
 *    viewer · operator 로 열면 값을 읽을 수 없으니 값 자리에 「admin 전용」이 선다. 조회 실패도 이 줄에만 선다.
 */
export function ModuleBrokerContainer({ moduleId }: { moduleId: string }) {
  const access = useScreenAccess()
  const { operations } = useMe()
  const canRead = canBroker(access, operations, MODULE_BROKER_READ)
  const connection = useModuleBrokerConnection({ moduleId, skip: !canRead })

  const notice = !canRead
    ? t('broker.adminOnly')
    : connection.isError
      ? errorMessage(connection.error)
      : undefined

  return (
    <ModuleBrokerRow
      {...(connection.data === undefined ? {} : { connection: connection.data })}
      loading={canRead && connection.isPending}
      {...(notice === undefined ? {} : { notice })}
    />
  )
}
